import React from "react";
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { BASE_API_URL } from "../constant";
// import tringlogo from "../images/tring.png";

function Register() {
    const [phoneNumber, setPhoneNumber] = useState("");
    const [password, setPassword] = useState("");

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const resp = await axios.post(BASE_API_URL + "api/user/login", {
                phoneNumber,
                password,
            });
            localStorage.setItem("token", resp.data.data.token);

            localStorage.setItem("userData", resp.data.data.phoneNumber);
            navigate("/user/prediction-number");
        } catch (err) {
            alert(err.response.data.msg);
        }
    }

    return (
        <div className="d-flex justify-content-center align-items-center">
            <div className="bg-white p-3">
                {/* <div className="mb-3">
                    <img src={tringlogo} alt="tring-logo" />
                </div> */}
                <h2 className="text-center mb-3">Login</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group mb-3">
                        <label htmlFor="phoneNumber">Phone Number</label>
                        <input type="phoneNumber" className="form-control" id="phoneNumber" placeholder="Enter Phone Number" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
                    </div>
                    <div className="form-group mb-3">
                        <label htmlFor="password">Password</label>
                        <input type="password" className="form-control" id="password" placeholder="Enter Password" value={password} onChange={(e) => setPassword(e.target.value)} />
                    </div>
                    <button type="submit" className="btn btn-success w-100 rounded-0">Login</button>
                </form>
                <p className="text-center mt-3">Don't have an account? <a href="/user/register" className="text-decoration-none">Register</a></p>
            </div>
        </div>
    )
}
export default Register;